import { PROMOTION_TYPE } from '../../constants/payment.constants';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { parse } from '../../util/urlHelpers';

const RESULT_PAGE_SIZE = 24;

export const FETCH_RECOMMENDED_LISTINGS_REQUEST =
  'app/RecommendedPage/FETCH_RECOMMENDED_LISTINGS_REQUEST';
export const FETCH_RECOMMENDED_LISTINGS_SUCCESS =
  'app/RecommendedPage/FETCH_RECOMMENDED_LISTINGS_SUCCESS';
export const FETCH_RECOMMENDED_LISTINGS_ERROR =
  'app/RecommendedPage/FETCH_RECOMMENDED_LISTINGS_ERROR';

const initialState = {
  pagination: null,
  queryInProgress: false,
  queryListingsError: null,
  queryParams: null,
  listings: null,
};

const recommendedPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_RECOMMENDED_LISTINGS_REQUEST:
      return {
        ...state,
        queryParams: payload.queryParams,
        queryInProgress: true,
        queryListingsError: null,
        listings: null,
      };
    case FETCH_RECOMMENDED_LISTINGS_SUCCESS:
      return {
        ...state,
        listings: payload.data?.data,
        pagination: payload.data?.meta,
        queryInProgress: false,
      };
    case FETCH_RECOMMENDED_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, queryInProgress: false, queryListingsError: payload };

    default:
      return state;
  }
};

export default recommendedPageReducer;

export const queryRecommendedListingsRequest = queryParams => ({
  type: FETCH_RECOMMENDED_LISTINGS_REQUEST,
  payload: { queryParams },
});
export const queryRecommendedListingsSuccess = response => ({
  type: FETCH_RECOMMENDED_LISTINGS_SUCCESS,
  payload: response,
});
export const queryRecommendedListingsError = e => ({
  type: FETCH_RECOMMENDED_LISTINGS_ERROR,
  payload: e,
});

export const queryRecommendedListings = queryParams => (dispatch, getState, sdk) => {
  dispatch(queryRecommendedListingsRequest(queryParams));

  return sdk.listings
    .query(queryParams)
    .then(response => {
      const denormalisedEntities = denormalisedResponseEntities(response);
      dispatch(
        queryRecommendedListingsSuccess({
          ...response,
          data: { ...response.data, data: denormalisedEntities },
        })
      );
      return response;
    })
    .catch(e => {
      dispatch(queryRecommendedListingsError(storableError(e)));
      throw e;
    });
};

export const loadData = (params, search, config) => dispatch => {
  const queryParams = parse(search);
  const page = queryParams.page || 1;

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const promotionPlan = [
    PROMOTION_TYPE.RECURRING.RECOMMENDED,
    PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED,
  ].join(',');

  return dispatch(
    queryRecommendedListings({
      ...queryParams,
      page,
      perPage: RESULT_PAGE_SIZE,
      include: ['images', 'author'],
      'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1,
      meta_promotionPlan: promotionPlan,
      sort: 'meta_order',
    })
  );
};
